export default {
  getExamResults: (state: any) => {
    return state.examResults;
  },
};
